// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e811220a","319":"a226ada0","337":"cf9c913a","453":"2d70e2cc","455":"8153ec22","977":"25ba943e"}[chunkId] + ".chunk.js";
};